import { EMPTY_DISPLAY_VALUE } from '../../constants/index.tsx';

export const displayApiContent = (value?: number | string | null) => {
  if (value === '') {
    return EMPTY_DISPLAY_VALUE;
  }
  return value ?? EMPTY_DISPLAY_VALUE;
};